var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExercise(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flat",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m424 248v26.43994a241.4224 241.4224 0 0 1 -22.65 102.10006 123.82715 123.82715 0 0 1 -214.25 17.78l-18.48-26.87-120.62-175.45h-24v-128a37.24211 37.24211 0 0 1 33.93 21.85l30.07 66.15 148.72 154.91992 43.28 45.08008 23.11-104z",
    fill: "#ffceb6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m424 152v96h-56v-16h-8a32.004 32.004 0 0 1 -32-32v-32a47.94823 47.94823 0 0 1 48-48h16a32.004 32.004 0 0 1 32 32z",
    fill: "#ffceb6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m424 248v26.43994a241.4224 241.4224 0 0 1 -22.65 102.10006 123.89051 123.89051 0 0 1 -15.12 24.49l-106.23-49.03 23.11-104z",
    fill: "#548aff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m424 152v56h-24l-32-32v-24h-37.27a48.026 48.026 0 0 1 45.27-32h16a32.004 32.004 0 0 1 32 32z",
    fill: "#b1712c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m386.23 401.03a123.82776 123.82776 0 0 1 -199.13-6.71l-18.48-26.87 68.1-60.53 43.28 45.08z",
    fill: "#ffc431"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m88 152-40 40h-24v-128a37.24211 37.24211 0 0 1 33.93 21.85z",
    fill: "#d1e4ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m447.99994 120h.00006a40 40 0 0 1 40 40v120a0 0 0 0 1 0 0h-.00006a63.99994 63.99994 0 0 1 -63.99994-63.99994v-72.00012a23.99994 23.99994 0 0 1 23.99994-23.99994z",
    fill: "#a36522"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#bdd1f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m128 440h312v16h-312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 440h16v16h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m456 440h16v16h-16z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m350.05888 238.05888-132.11776-132.11776a33.9411 33.9411 0 0 0 -24-9.94112 33.94109 33.94109 0 0 0 -33.94112 33.94109 33.9411 33.9411 0 0 0 9.94112 24l132.11776 132.11779a33.9411 33.9411 0 0 0 24 9.94112h.00005a33.94109 33.94109 0 0 0 33.94107-33.94109v-.00005a33.9411 33.9411 0 0 0 -9.94112-23.99998z",
    fill: "#ffceb6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/exercise.538886794be7878eaa794d8ee685566b.svg";
export { ForwardRef as ReactComponent };